<template>
  <div class="box">
    <div class="block-title">会员统计</div>
    <div id="" class="">
      <div id="fb01" ref="chartDiv" style="float: left; width: 100%; height: 180px; padding: 20px"></div>
      <!-- <div id="fb02" style="float: left; width: 50%; height: 180px"></div> -->
    </div>
    <div class="leidanav leidanav2">
      <ul class="clearfix">
        <li>
          <span>会员总人数</span>
          <p>{{ memberTrendInfo.TotalNum }}</p>
        </li>
        <li>
          <span>集团会员</span>
          <p>{{ memberTrendInfo.GroupNum }}</p>
        </li>
        <li>
          <span>个人会员</span>
          <p>{{ memberTrendInfo.PersonalNum }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';

export default {
	data() {
		return {
			memberTrendChart: null,
			memberTrendInfo: {},
		}
	},
	mounted() {
		this.memberTrendChart = echarts.init(this.$refs.chartDiv);
		this.memberTrendChart.setOption(chartOption);
		window.addEventListener('resize', () => this.memberTrendChart.resize());
	},
	methods: {
		setData(data) {
			this.memberTrendInfo = data;
			chartOption.xAxis.data = data.Curves.TimePoints;
			chartOption.series[0].data = data.Curves.ActiveNums;
			chartOption.series[1].data = data.Curves.NewlyNums;
			this.memberTrendChart.setOption(chartOption);
		}
	}
}

const chartOption = {
  //  backgroundColor: '#00265f',
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
  },
  legend: {
    data: ['活跃会员', '新增会员'],
    textStyle: {
      color: '#929ca8',
    },
  },
  grid: {
    left: 0,
    top: 30,
    right: 0,
    bottom: '0',
    containLabel: true,
  },
  xAxis: {
    type: 'category',
    data: [],
    axisLine: {
      show: true,
      lineStyle: {
        color: 'rgba(255,255,255,.1)',
        width: 1,
        type: 'solid',
      },
    },
    axisTick: {
      show: false,
    },
    axisLabel: {
      interval: 0,
      // rotate:50,
      show: true,
      splitNumber: 5,
      color: 'rgba(255,255,255,.6)',
      fontSize: '12',
    },
  },
  yAxis: [
    {
      name: '活跃会员',
      type: 'value',
      scale: true,
      minInterval: 100,
      axisLabel: {
        // formatter: '{value} %'
        show: true,
        color: 'rgba(255,255,255,.6)',
        fontSize: '12',
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: 'rgba(255,255,255,.1	)',
          width: 1,
          type: 'solid',
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: 'rgba(255,255,255,.1)',
        },
      },
      nameTextStyle: {
        color: 'rgba(255,255,255,0.5)',
      },
    },
    {
      name: '新增会员',
      type: 'value',
      minInterval: 50,
      scale: true,
      axisLabel: {
        // formatter: '{value} %'
        show: true,
        color: 'rgba(255,255,255,.6)',
        fontSize: '12',
      },
      axisTick: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: 'rgba(255,255,255,.1	)',
          width: 1,
          type: 'solid',
        },
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: 'rgba(255,255,255,.1)',
        },
      },
      nameTextStyle: {
        color: 'rgba(255,255,255,0.5)',
      },
    },
  ],
  series: [
    {
      name: '活跃会员',
      type: 'line',
      // smooth: true,
      data: [22, 46, 23, 48, 35, 28],
      yAxisIndex: 0,
      itemStyle: {
        color: '#2f89cf',
        opacity: 1,

        barBorderRadius: 5,
      },
    },
    {
      name: '新增会员',
      type: 'line',
      // smooth: true,
      data: [2, 6, 3, 8, 5, 8],
      yAxisIndex: 1,
      itemStyle: {
        color: '#2fe9cf',
        opacity: 1,

        barBorderRadius: 5,
      },
    },
  ],
};
</script>
<style scoped>
@import '../style.css';
</style>
